
<template>
    <div class="text-center col-6 pt-4">
        <notifications></notifications>
        <div v-if="!isError" class="loader float-right"></div>
        <div class="color-red float-left" v-else><h3>Operation can not be proccessed</h3></div>
    </div>
</template>

<script>
    import ResourceSvc from '@/services/resource.svc.js';
    const Request = new ResourceSvc();
    export default {
        name: 'QuickEntry',
        data() {
            return {
                isError: false,
            }
        },
        methods: {
            load() {
                var self = this;
                Request.prepareRaceEntryTempData(this.$route.params.rId, this.$route.params.oId)
                    .then(response => {
                        //to do: replace with new errors
                        if (response && response.body && response.body.isSuccess) {
                            self.$router.push({ path: '/race-entry/billing/' + self.$route.params.rId });
                        } else {
                            self.isError = true;
                            self.$notify({
                                message: response.body.message ? response.body.message : "Something went wrong. Request is not correct.",
                                type: 'danger',
                                timeout: 4000
                            });

                            return;
                            setTimeout(() => {
                                self.$notify({
                                    message: 'You will be redictected in 2,5 seconds. Have a nice day.',
                                    type: 'danger',
                                    timeout: 2000
                                });
                            }, 3500);
                            setTimeout(() => {
                                self.$router.push({ path: '/dashboard/races' })
                            }, 6000)
                        }
                    },
                        err => {
                            self.isError = true;
                        });
            }
        },
        created() {
            this.load();
            //this.$router.push({ path: '/dashboard' });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/user/races/quick-entry/quick-entry.vue